import { SprintIcon } from '../../assets/CustomIcons/SprintIcon';
import { ClockCircleOutlined, ProjectOutlined } from '@ant-design/icons';
import CustomTooltip from './Tooltip/CustomTooltip';
import { ArchiveBox } from '../../assets/CustomIcons/ArchiveBox';
import { BacklogCircle } from '../../assets/CustomIcons/BacklogCircle';
import { TriageTriangle } from '../../assets/CustomIcons/TriageTriangle';

export const SprintStatusOptions = ['triage', 'none', 'planning', 'sprint', 'kanban', 'archive'] as const;

export type SprintStatusType = (typeof SprintStatusOptions)[number];

const SprintStatusComponentOptions = ['table', 'dropdown'] as const;

export type SprintStatusComponentType = (typeof SprintStatusComponentOptions)[number];

const ComponentTextWidthMap: { [x in SprintStatusComponentType]: number } = {
  table: 80,
  dropdown: 125,
};

const SprintStatusIconMap: { [x in SprintStatusType]: JSX.Element } = {
  triage: <TriageTriangle />,
  planning: <ClockCircleOutlined />,
  sprint: <SprintIcon />,
  kanban: <ProjectOutlined />,
  none: <BacklogCircle />,
  archive: <ArchiveBox />,
};
const SprintStatusTextMap: { [x in SprintStatusType]: string } = {
  triage: 'Triage',
  planning: 'Planning',
  sprint: 'Sprint',
  kanban: 'Kanban',
  none: 'Backlog',
  archive: 'Archive',
};
export const SprintStatusColorMap: { [x in SprintStatusType]: { text: string; background: string } } = {
  triage: { text: 'text-orange-600', background: 'bg-orange-100' },
  none: { text: 'text-neutral-900', background: 'bg-neutral-200' },
  planning: { text: 'text-blue-600', background: 'bg-blue-100' },
  sprint: { text: 'text-yellow-600', background: 'bg-yellow-100' },
  kanban: { text: 'text-orange-600', background: 'bg-orange-100' },
  archive: { text: 'text-neutral-700', background: 'bg-neutral-200' },
};

export type SprintStatusLabelProps = {
  className?: string;
  sprintStatus: SprintStatusType;
  component: SprintStatusComponentType;
};

const SprintStatusLabel: React.FC<SprintStatusLabelProps> = (sprintStatusProps) => {
  const maxWidth = ComponentTextWidthMap[sprintStatusProps.component] || 80;

  const textStyle = {
    maxWidth: maxWidth,
  };

  const statusLabel = (
    <div
      className={`h-5 max-w-[225px] inline-flex gap-1 items-center py-1 px-2 rounded text-sm font-normal  ${SprintStatusColorMap[sprintStatusProps.sprintStatus].background} ${SprintStatusColorMap[sprintStatusProps.sprintStatus].text} ${sprintStatusProps.className || ''}`}
    >
      {SprintStatusIconMap[sprintStatusProps.sprintStatus]}
      <div style={textStyle} className={`h-5 whitespace-nowrap overflow-hidden text-ellipsis`}>
        {SprintStatusTextMap[sprintStatusProps.sprintStatus]}
      </div>
    </div>
  );

  if (sprintStatusProps.component === 'dropdown' || maxWidth) {
    return statusLabel;
  }
  return <CustomTooltip title={SprintStatusTextMap[sprintStatusProps.sprintStatus]}>{statusLabel}</CustomTooltip>;
};

export { SprintStatusLabel };
